import axiosInstance from '../axiosConfigCMS';

export default {
  async getLinks() {
    const response = await axiosInstance.get('/menu-about-links');
    return response.data;
  },
  async getContent() {
    const response = await axiosInstance.get('/menu-about-banner');
    return response.data;
  },
  async getAddress() {
    const response = await axiosInstance.get('/address');
    return response.data;
  },
};
